/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import ApproveTeam from "./ApproveTeam";
import DenyTeam from "./DenyTeam";
import { Box } from "@material-ui/core";
import { INotification } from "pages/home/notifications/components/NotificationList.controller";
export interface NotificationActionsProps {
  notification: INotification;
  refreshApprovals : () => void
}
export const TeamNotificationActions: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  return (
    <>
      <Box display="flex">
        <ApproveTeam notification={notification} refreshApprovals={refreshApprovals}/>
        <Box mx={1} />
        <DenyTeam notification={notification} refreshApprovals={refreshApprovals}/>
      </Box>
    </>
  );
};

export default TeamNotificationActions;
